var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.75C8.9665 21.75 9.75 20.9665 9.75 20C9.75 19.0335 8.9665 18.25 8 18.25C7.0335 18.25 6.25 19.0335 6.25 20C6.25 20.9665 7.0335 21.75 8 21.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.75C16.9665 21.75 17.75 20.9665 17.75 20C17.75 19.0335 16.9665 18.25 16 18.25C15.0335 18.25 14.25 19.0335 14.25 20C14.25 20.9665 15.0335 21.75 16 21.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.17 5.85023C18.84 5.47023 18.36 5.25023 17.85 5.25023H6C6 5.25023 5.95 5.26023 5.93 5.26023L5.89 4.78023C5.78 3.36023 4.58 2.24023 3.15 2.24023H3C2.59 2.24023 2.25 2.58023 2.25 2.99023C2.25 3.40023 2.59 3.74023 3 3.74023H3.15C3.8 3.74023 4.35 4.25023 4.4 4.89023L5.05 13.2702C5.2 15.2102 6.84 16.7302 8.79 16.7302H18.01C18.42 16.7302 18.76 16.3902 18.76 15.9802C18.76 15.5702 18.42 15.2302 18.01 15.2302H8.78C7.81 15.2302 6.98 14.6002 6.67 13.7302H15.4C17.25 13.7302 18.85 12.3502 19.11 10.5102L19.58 7.23023C19.65 6.73023 19.5 6.22023 19.17 5.84023V5.85023ZM17.63 10.3102C17.47 11.4102 16.51 12.2402 15.4 12.2402H6.46L6.04 6.74023H17.85C17.95 6.74023 18.01 6.79023 18.04 6.83023C18.07 6.86023 18.11 6.93023 18.1 7.03023L17.63 10.3102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.07c0a8c656e207de957c9b7630d0632e.svg";
export { ForwardRef as ReactComponent };